import { RunReview, RunReviewDecision } from "types/generated";
import Box from "ds/components/Box";
import { TreeBranch, TreeBranchLink, TreeItem } from "ds/components/Tree";
import Timestamp from "components/Timestamp";
import Separator from "components/Run/elements/HistoryEntryWrapper/Separator";
import HistoryEntryNote from "components/Run/elements/HistoryEntryNote";
import HistoryEntryLabel from "components/Run/elements/HistoryEntryLabel";

type ReviewProps = {
  review: RunReview;
};

function Review({ review }: ReviewProps) {
  return (
    <TreeBranch align="start">
      <TreeBranchLink>
        <TreeItem autoHeight align="start">
          <Box gap="medium" align="center" padding="medium 0">
            <HistoryEntryLabel>
              <i>{review.author}</i>{" "}
              {review.decision === RunReviewDecision.Approve ? "approved" : "rejected"}
            </HistoryEntryLabel>

            <Separator margin="0" />

            <Timestamp color="secondary" timestamp={review.timestamp} />
          </Box>
        </TreeItem>
      </TreeBranchLink>

      {review.note && (
        <TreeItem autoHeight direction="column" align="start">
          <HistoryEntryNote margin="0 0 medium">{review.note}</HistoryEntryNote>
        </TreeItem>
      )}
    </TreeBranch>
  );
}

export default Review;
